export enum OPENING_CONFIGURATION_TYPE {
  CONSTANT = 'CONSTANT',
  DAILY = 'DAILY',
}

export type OpeningConfigurationType =
  (typeof OPENING_CONFIGURATION_TYPE)[keyof typeof OPENING_CONFIGURATION_TYPE];
